import React from "react";

import { incomplete, truncateCredits } from "utils";

import { Button, Col, Drawer, Form, InputNumber, Option, Row, Select } from "components";

export const MethodsAssignmentDrawer = ({
  showAssignmentDrawer,
  handleCloseAssignmentDrawer,
  form,
  complete,
  currentFarmFieldMethod,
  remainingMethodCredits,
  handlePartnerChange,
  partners,
  currentPartner,
  remainingPartnerCredits,
  quantity,
  setQuantity,
  loading,
}) => (
  <Drawer title="Assign credits to partner" visible={showAssignmentDrawer} onClose={handleCloseAssignmentDrawer}>
    <Form name="creditAssignment" onFinish={complete} onFinishFailed={incomplete} ref={form}>
      <Row>
        <Col>
          <span className="paragraph-s grey-text">Farm</span>
          <p>{currentFarmFieldMethod?.farmName}</p>
          <span className="paragraph-s grey-text">Field</span>
          <p>{currentFarmFieldMethod.fieldName}</p>
          <span className="paragraph-s grey-text">Method Name</span>
          <p>{currentFarmFieldMethod.methodName}</p>
          <span className="paragraph-s grey-text">Next Task</span>
          <p>{currentFarmFieldMethod.nextTask}</p>
        </Col>
      </Row>
      <Row className="center">
        <Col sm={8} md={8}>
          <span className="paragraph-s grey-text">Credits</span>
          <p>{truncateCredits(currentFarmFieldMethod.totalCredits)}</p>
        </Col>
        <Col sm={8} md={8}>
          <span className="paragraph-s grey-text">Assigned</span>
          <p>{truncateCredits(currentFarmFieldMethod.assignedCredits)}</p>
        </Col>
        <Col sm={8} md={8}>
          <span className="paragraph-s grey-text">Remaining</span>
          <p>{truncateCredits(remainingMethodCredits)}</p>
        </Col>
      </Row>
      <Row>
        <Col>
          <Select label="Select a partner" name="partnerId" rules={[{ required: true }]} message={"This is required"} onChange={handlePartnerChange}>
            {partners.map((partner, i) => (
              <Option value={partner.id} key={i}>
                {partner.name}
              </Option>
            ))}
          </Select>
        </Col>
      </Row>
      {currentPartner && (
        <>
          <Row className="center">
            <Col sm={8} md={8}>
              <span className="paragraph-s grey-text">Purchased credits</span>
              <p>{truncateCredits(currentPartner.purchasedCredits)}</p>
            </Col>
            <Col sm={8} md={8}>
              <span className="paragraph-s grey-text">Purchase obligations</span>
              <p>{truncateCredits(currentPartner.purchaseObligations)}</p>
            </Col>
            <Col sm={8} md={8}>
              <span className="paragraph-s grey-text">Remaining credits</span>
              <p>{truncateCredits(remainingPartnerCredits)}</p>
            </Col>
          </Row>
          <Row>
            <Col sm={24} md={12}>
              <InputNumber
                label="Quantity"
                name="quantity"
                min={0}
                rules={[{ required: true }]}
                message={"This is required"}
                onChange={(v) => setQuantity(v)}
                defaultValue={quantity}
              />
            </Col>
            <Col sm={24} md={12}>
              <Select initialValue={"Offsetting"} name="creditType" label="creditType" rules={[{ required: true }]}>
                <Option value={"Insetting"}>Insetting</Option>
                <Option value={"Offsetting"}>Offsetting</Option>
              </Select>
            </Col>
          </Row>
          <Row>
            <Col>
              <Button block type="primary" htmlType="submit" disabled={loading} loading={loading}>
                {currentPartner ? `Assign credits to ${currentPartner.name}` : "Assign credits"}
              </Button>
            </Col>
          </Row>
        </>
      )}
    </Form>
  </Drawer>
);
